import React from 'react';
import { MapPin, Navigation } from 'lucide-react';

const LocationSection = () => {
  const address = "Shop 25 & 26, Aklavya CHS, Plot No 69 D/J/K, Sector 21, Kharghar, 410210";
  const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.2887446803356!2d73.0681748!3d19.051038299999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c3001e9af413%3A0x43ce6ceb44da05c3!2sAdhyan%20Library!5e0!3m2!1sen!2sin!4v1773118001066!5m2!1sen!2sin";
  const openInMaps = () => {
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=Adhyan+Library+Sector+21+Kharghar`;
    window.open(mapsUrl, '_blank');
  };

  return (
    <div className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">
            Visit Us
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Our Location
          </h2>
          <p className="text-lg text-gray-600">
            Conveniently located in Kharghar Sector 21, easily accessible by public transport
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Map */}
          <div className="relative rounded-3xl overflow-hidden shadow-2xl h-[500px] group">
            <iframe
              src={mapEmbedUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Adhyan Study Spaces Location"
              className="grayscale group-hover:grayscale-0 transition-all duration-500"
            ></iframe>
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none"></div>
          </div>

          {/* Address Card */}
          <div className="flex flex-col justify-center space-y-6">
            <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-200">
              <div className="flex items-start gap-4 mb-6">
                <div className="bg-blue-100 p-4 rounded-xl">
                  <MapPin className="text-blue-600" size={32} />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">Address</h3>
                  <p className="text-gray-600 text-lg leading-relaxed">
                    {address}
                  </p>
                </div>
              </div>

              <button
                onClick={openInMaps}
                className="w-full bg-blue-600 text-white py-4 rounded-xl font-semibold hover:bg-blue-700 transition-all duration-300 hover:scale-105 shadow-lg flex items-center justify-center gap-2 group"
              >
                <Navigation size={20} className="group-hover:rotate-45 transition-transform" />
                Get Directions
              </button>
            </div>

            {/* Quick Info Cards */}
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-blue-50 rounded-2xl p-6 border-2 border-blue-200">
                <p className="text-sm text-blue-700 font-semibold mb-1">Area</p>
                <p className="text-2xl font-bold text-blue-900">Sector 21</p>
              </div>
              <div className="bg-sky-50 rounded-2xl p-6 border-2 border-sky-200">
                <p className="text-sm text-sky-700 font-semibold mb-1">City</p>
                <p className="text-2xl font-bold text-sky-900">Kharghar</p>
              </div>
            </div>

            {/* Landmark Info */}
            <div className="bg-gradient-to-br from-blue-50 to-sky-50 rounded-2xl p-6 border border-blue-200">
              <h4 className="font-bold text-gray-900 mb-3">How to Reach:</h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 mt-1">•</span>
                  <span>Located in Aklavya CHS complex</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 mt-1">•</span>
                  <span>Near Sector 21 bus stop</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 mt-1">•</span>
                  <span>Easy access from Kharghar railway station</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationSection;
